import { faSmile, faDrawPolygon, faPercentage }
    from '@fortawesome/free-solid-svg-icons';



export const AI_FACES_TABLE_HEADER = [
    { name: "Subjects", intl: "aiview.subject", icon: faSmile },
    { name: "Probability", intl: "aiview.probability", icon: faPercentage },
    { name: "Position", intl: "aiview.position", icon: faDrawPolygon },
]
